<template>
  <PressReleaseDetails
    v-if="!loader"
    :file="featuredFile"
    :featured="true"
    data-aos="fade-in"
    data-aos-easing="ease-in-out"
    data-aos-duration="1000"
  >
    <MarkdownPreview v-if="!readMore" :text="previewText" />
    <transition name="fade">
      <MarkdownPreview v-if="readMore" :text="featuredFile.JSON.body" />
    </transition>

    <div class="text-center" v-if="showReadMoreButton">
      <p class="text-style" v-if="!readMore" @click="toggleReadMore">
        read more
      </p>
      <p v-else class="text-style" @click="toggleReadMore">close</p>
    </div>

    <LineBreak class="my-3" />
  </PressReleaseDetails>
</template>

<script>
import MarkdownPreview from "../../MarkdownPreview.vue";
import LineBreak from "../../LineBreak.vue";
import PressReleaseDetails from "./PressReleaseDetails.vue";
import { mapGetters, mapActions } from "vuex";
import "../../../utils/filters";

export default {
  name: "FeaturedPressRelease",
  props: {
    identifier: String,
  },

  components: {
    MarkdownPreview,
    LineBreak,
    PressReleaseDetails,
  },

  data() {
    return {
      featuredFile: "",
      loader: false,
      readMore: false,
      showReadMoreButton: false,
    };
  },

  computed: {
    ...mapGetters(["file"]),

    previewText() {
      return this.featuredFile.JSON.body.slice(0, 400);
    },
  },

  methods: {
    ...mapActions(["fetchFile", "hideLoader", "showLoader"]),

    openLink() {
      const linkToOpen = this.featuredFile.URL
        ? this.featuredFile.URL
        : this.featuredFile.JSON.link;
      window.open(linkToOpen, "_blank");
    },

    toggleReadMore() {
      this.readMore = !this.readMore;
    },
  },

  async created() {
    this.loader = true;
    await this.fetchFile(this.identifier);
    this.featuredFile = this.file;
    this.loader = false;

    const bodyLength = this.featuredFile.JSON.body.length;
    this.showReadMoreButton = bodyLength > 400;
  },
};
</script>

<style scoped>
.text-style {
  @apply inline-block font-AvenirBlackFont text-STorange hover:underline cursor-pointer;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>

